<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <router-link to="/allServicePartners">All Service Partners</router-link>
        </li>
      </ol>
      <div class="row">
        <div class="col-md-12">
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
                @keyup.enter="getAllUsers(1)"
              />
            </div>
          </div>
        </div>

        <div class="col-md-1">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllUsers(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label for="userStatusFilter">User Status</label>
            <select
              id="userStatusFilter"
              class="form-control"
              v-model="userStatusFilter"
              @change="getAllUsers(1)"
            >
              <option value="all">All</option>
              <option value="verified">Verified</option>
              <option value="not_verified">Not Verified</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label for="partnerTypeFilter">User Type</label>
            <select
              id="partnerTypeFilter"
              class="form-control"
              v-model="partnerTypeFilter"
              @change="getAllUsers(1)"
            >
              <option value="all">All Types</option>
              <option value="Reborer">Reborer</option>
              <option value="Mechanics">Mechanic</option>
              <option value="Grinder">Grinder</option>
              <option value="ReborerPlusGrinder">Grinder Reborer</option>
            </select>
          </div>
        </div>

        <div class="col-md-4 form-group" style="padding-top: 20px;">
          <div style="float:left;margin-right:10px;">
            <button class="btn btn-danger submitbtn btn-raised" @click="$router.push('/allServicePartnersDeleted')">
              Delete List <i class="material-icons">delete</i>
            </button>
          </div>
          <div>
            <button class="btn btn-default submitbtn btn-raised" @click="export_file">
              Export <i class="material-icons">file_download</i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button type="button" class="btn btn-default">
            New KYC Request&nbsp;<span class="badge">{{ NewVerificationCount }}</span>
          </button>
          <button type="button" class="btn btn-default">
            Total Service Partners&nbsp;<span class="badge">{{ VerifiedCount }}</span>
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="selected.length === 0 ? showSelectError() : (showBulkVerifyModal = true)"
            style="margin-left: 20px; color: #fff;"
          >
            Bulk Verify
          </button>
        </div>

        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll"></th>
                    <th>#</th>
                    <th>Partner ID</th>
                    <th>User Type</th>
                    <th>Partner Name</th>
                    <th>Address</th>
                    <th>PIN Code</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Total Points Accumulated</th>
                    <th>Point Balance</th>
                    <th>Total Points Redeemed</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td><input type="checkbox" v-model="selected" :value="item.entity_id"></td>
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: getEditRoute(item.PartnerType),
                          params: { partner_id: item.UserCode },
                        }"
                      >
                        {{ item.UserCode }}
                      </router-link>
                    </td>
                    <td>
                      <span class="label label-info" style="font-size: 11px; padding: 3px 7px;">
                        {{ item.PartnerType | formatPartnerType }}
                      </span>
                    </td>
                    <td>{{ item.first_name | removeNull }} {{ item.last_name | removeNull }}</td>
                    <td>{{ item.AddressLine1 | removeNull }} {{ item.AddressLine2 | removeNull }}</td>
                    <td>{{ item.ZIP | removeNull }}</td>
                    <td>{{ item.State | removeNull }}</td>
                    <td>{{ item.selectedCity | removeNull }}</td>
                    <td>{{ item.TotalPoints | removeNull }}</td>
                    <td>{{ (item.TotalPoints - item.RedeemptionPoints) | setnullZero }}</td>
                    <td>{{ item.RedeemptionPoints | setnullZero }}</td>
                    <td>
                      <a v-on:click="approveRequest(item.entity_id)" v-if="!parseInt(item.is_verified)">
                        <i class="glyphicon glyphicon-ok"></i> Verify
                      </a>
                      <span v-if="!parseInt(item.is_verified)"> | </span>

                      <a v-on:click="showKYCRequest(item.UserCode)" v-if="item.ApprovalStatus == 'Requestd'">
                        <i class="glyphicon glyphicon-check"></i>&nbsp; KYC
                      </a>
                      <span v-if="item.ApprovalStatus == 'Requestd'"> | </span>

                      <a href="#" @click.prevent="DeactivateEmployee(item.id)">
                        {{ item.active === "1" ? "Active" : "InActive" }}
                      </a>
                      |
                      <router-link
                        :to="{
                          name: 'editUserType',
                          params: { email: item.email },
                        }"
                      >
                        Change User Type
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="users_data.length === 0">
                    <td colspan="13" class="text-center">No records found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllUsers"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                v-model="refreshPageState"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KYC Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close button" @click="showModal = false">
                    <span aria-hidden="false">X</span>
                  </button>
                  <h4 class="modal-title">KYC Approval Request ( {{ KYCData.UserCode }} )</h4>
                </div>
                <div class="modal-body">
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <tr><td class="align-left">Driving Licence No</td><td class="align-left">: {{ KYCData.DrivingLicenseNo }}</td></tr>
                      <tr><td class="align-left">Aadhar Card No</td><td class="align-left">: {{ KYCData.AadharCardNo }}</td></tr>
                      <tr><td class="align-left">PAN No</td><td class="align-left">: {{ KYCData.PANNo }}</td></tr>
                      <tr><td class="align-left">Date Of Birth No</td><td class="align-left">: {{ KYCData.DateOfBirth }}</td></tr>
                      <tr><td class="align-left">Size Of Workshop</td><td class="align-left">: {{ KYCData.SizeOfWorkshop }}</td></tr>
                      <tr><td class="align-left">Service Per Month</td><td class="align-left">: {{ KYCData.ServicePerMonth }}</td></tr>
                      <tr><td class="align-left">Gender</td><td class="align-left">: {{ KYCData.Gender }}</td></tr>
                      <tr><td class="align-left">Year Of Experience</td><td class="align-left">: {{ KYCData.YearOfExperience }}</td></tr>
                      <tr><td class="align-left">EnginesOverhauled</td><td class="align-left">: {{ KYCData.EnginesOverhauled }}</td></tr>
                      <tr><td class="align-left">GSTN</td><td class="align-left">: {{ KYCData.GSTN }}</td></tr>
                    </table>
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="varifyKYCRequest" class="btn btn-primary">Approve</button>
                  <button @click="showModal = false" class="btn btn-cancle">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Bulk Verify Confirmation Modal -->
    <div v-if="showBulkVerifyModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close button" @click="showBulkVerifyModal = false">
                    <span aria-hidden="false">X</span>
                  </button>
                  <h4 class="modal-title">Bulk Verify Confirmation</h4>
                </div>
                <div class="modal-body">
                  <p>Are you sure you want to verify the selected Service Partners ({{ selected.length }})?</p>
                </div>
                <div class="modal-footer">
                  <button @click="showBulkVerifyModal = false" class="btn btn-default">Cancel</button>
                  <button @click="showBulkVerifyModal = false; bulkVerify();" class="btn btn-primary">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../../services/common-services';

export default {
  name: 'AllServicePartners',
  components: {
    Paginate,
  },
  data() {
    return {
      refreshPageState: 1,
      KYCData: '',
      showModal: false,
      users_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 0,
      NewVerificationCount: 0,
      VerifiedCount: 0,
      SuccessMessage: '',
      ErrorMessage: '',
      userStatusFilter: 'all',
      partnerTypeFilter: 'all',
      selectAll: false,
      selected: [],
      showBulkVerifyModal: false,
    };
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
    this.getAllUsers(this.refreshPageState);
  },
  methods: {
    getEditRoute(type) {
      if (!type) return 'editReborer';
      switch (type) {
        case 'Mechanics':
        case 'Mechanic':
          return 'editMechanic';
        case 'Grinder':
          return 'editGrinder';
        case 'ReborerPlusGrinder':
          return 'editGrinderReborer';
        case 'Reborer':
        default:
          return 'editReborer';
      }
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      if (searchText) {
        params['searchText'] = searchText;
      }
      if (page) {
        params['page'] = page - 1;
      }
      if (pageSize) {
        params['size'] = pageSize;
      }
      params['active'] = "1";
      if (this.userStatusFilter && this.userStatusFilter !== 'all') {
        params['userStatus'] = this.userStatusFilter;
      }
      params['partnerType'] = (this.partnerTypeFilter && this.partnerTypeFilter !== 'all') ? this.partnerTypeFilter : 'all';
      return params;
    },
    getAllUsers(pageNum) {
      let loader = this.$loading.show();
      this.refreshPageState = pageNum || 1;
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/Reborer/list', params)
        .then((response) => {
          const {
            users_data,
            currentPage,
            TotalPage,
            NewVerificationCount,
            VerifiedCount,
          } = response.data;
          this.users_data = users_data || [];
          this.TotalPage = TotalPage || 1;
          this.currentPage = parseInt(currentPage) || 0;
          this.NewVerificationCount = NewVerificationCount || 0;
          this.VerifiedCount = VerifiedCount || 0;
          this.selectAll = false;
          this.selected = [];
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
        })
        .finally(() => {
          setTimeout(() => { loader.hide(); }, 500);
        });
    },
    DeactivateEmployee(id) {
      if (confirm('Do you want to continue?')) {
        let params = "id=" + id;
        commonServices
          .delete('kspgAPI/BrandEmployee', params)
          .then((response) => {
            this.SuccessMessage = response.data.message || response.data.Messaage;
            if (response.data.status) {
              this.getAllUsers(this.refreshPageState);
            }
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
              this.$router.push({ name: 'login' });
            }
            this.ErrorMessage =
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              e.toString();
          })
          .finally(() => {
            setTimeout(() => (this.SuccessMessage = false), 5000);
            setTimeout(() => (this.ErrorMessage = false), 5000);
          });
      }
    },
    approveRequest(entity_id) {
      if (confirm('Do you want to continue?')) {
        let loader = this.$loading.show();
        let data = { entity_id: entity_id };
        commonServices
          .put('kspgAPI/Partners/approve', data)
          .then((response) => {
            this.SuccessMessage = response.data.message;
            if (response.data.status) {
              this.getAllUsers(this.refreshPageState);
            }
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
              this.$router.push({ name: 'login' });
            }
            this.ErrorMessage =
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              e.toString();
          })
          .finally(() => {
            loader.hide();
            setTimeout(() => (this.SuccessMessage = false), 5000);
            setTimeout(() => (this.ErrorMessage = false), 5000);
          });
      }
    },
    showKYCRequest(userCode) {
      if (confirm('Do you want to continue?')) {
        let loader = this.$loading.show();
        this.showModal = true;
        let data = { userCode: userCode };
        commonServices
          .get('kspgAPI/Partners/kyc', data)
          .then((response) => {
            const { data } = response.data;
            this.KYCData = data;
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
              this.$router.push({ name: 'login' });
            }
          })
          .finally(() => {
            setTimeout(() => { loader.hide(); }, 500);
          });
      }
    },
    varifyKYCRequest() {
      let data = { userCode: this.KYCData.UserCode };
      commonServices
        .put('kspgAPI/Partners/kyc', data)
        .then((response) => {
          this.SuccessMessage = response.data.message;
          if (response.data.status) {
            this.showModal = false;
            this.getAllUsers(this.refreshPageState);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
          this.ErrorMessage =
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            e.toString();
        })
        .finally(() => {
          setTimeout(() => (this.SuccessMessage = false), 5000);
          setTimeout(() => (this.ErrorMessage = false), 5000);
        });
    },
    toggleSelectAll() {
      this.selected = this.selectAll ? this.users_data.map(item => item.entity_id) : [];
    },
    showSelectError() {
      this.ErrorMessage = 'Please select at least one Service Partner to verify.';
      setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    bulkVerify() {
      if (this.selected.length === 0) {
        this.showSelectError();
        return;
      }
      let loader = this.$loading.show();
      const data = { entity_ids: this.selected };
      commonServices
        .put('kspgAPI/Reborer/bulk_verify', data)
        .then((response) => {
          this.SuccessMessage = response.data.message;
          if (response.data.status) {
            this.getAllUsers(this.refreshPageState);
            this.selected = [];
            this.selectAll = false;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
          this.ErrorMessage =
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            e.toString();
        })
        .finally(() => {
          loader.hide();
          setTimeout(() => (this.SuccessMessage = false), 5000);
          setTimeout(() => (this.ErrorMessage = false), 5000);
        });
    },
    export_file() {
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/Reborer/export', params)
        .then((response) => {
          if (response.data.status) {
            var link = document.createElement('a');
            link.href = response.data.filepath;
            link.target = '_blank';
            link.click();
          } else {
            alert(response.data.message);
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error === 'Invalid API key ') {
            this.$router.push({ name: 'login' });
          }
          alert((e.response && e.response.data && e.response.data.message) || e.message);
        })
        .finally(() => {
          setTimeout(() => { loader.hide(); }, 1000);
        });
    },
  },
  filters: {
    removeNull(data) {
      if (!data) return '';
      return data;
    },
    setnullZero(data) {
      if (!data) return '0';
      return data;
    },
    formatPartnerType(type) {
      if (!type) return '';
      switch (type) {
        case 'Mechanics':
          return 'Mechanic';
        case 'ReborerPlusGrinder':
          return 'Grinder Reborer';
        default:
          return type;
      }
    },
  },
};
</script>

<style scoped>
.visibility {
  visibility: visible !important;
}
.btn-primary {
  background-color: #007bff !important;
  color: #fff !important;
  border: none;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #0056b3 !important;
  color: #fff !important;
  border: none;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.close {
  color: #000 !important;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.align-left {
  text-align: left !important;
  padding-left: 10px;
}
</style>
